import { Text, Tooltip } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { djs } from '@duke-hq/djs';
import React from 'react';

interface SupersededCourseStatusBadgeProps {
  status: string;
  supersedingCourse?: {
    identifier: string | null;
    title: string;
  } | null;
  teachOutEndDate?: Date | null;
}

function SupersededCourseStatusBadge({
  status,
  supersedingCourse,
  teachOutEndDate,
}: SupersededCourseStatusBadgeProps): React.JSX.Element {
  const hasTeachOutDatePassed =
    teachOutEndDate != null && djs(teachOutEndDate).isBefore(djs(), 'day');

  const tooltipLabel =
    supersedingCourse != null && teachOutEndDate != null ? (
      hasTeachOutDatePassed ? (
        <Trans>
          This course has been <strong>superseded</strong> by{' '}
          <strong>{supersedingCourse.identifier ?? supersedingCourse.title}</strong>. All enrolments
          should have been completed or transferred by{' '}
          <strong>{djs(teachOutEndDate).format('DD/MM/YY')}</strong>.
        </Trans>
      ) : (
        <Trans>
          This course has been <strong>superseded</strong> by{' '}
          <strong>{supersedingCourse.identifier ?? supersedingCourse.title}</strong>. All enrolments
          must be complete or transferred by{' '}
          <strong>{djs(teachOutEndDate).format('DD/MM/YY')}</strong>.
        </Trans>
      )
    ) : undefined;

  const formattedStatus = status
    .toLowerCase()
    .replace(/(^\w|[_\s-]\w)/g, (match) => match.replace(/[_\s-]/, '').toUpperCase());

  return (
    <Tooltip label={tooltipLabel} hasArrow placement="top">
      <Text as="span" color="red.500" fontWeight="bold" fontSize="xs">
        {formattedStatus}
      </Text>
    </Tooltip>
  );
}

export default SupersededCourseStatusBadge;
